import React, { useState, useEffect } from "react";
import get from "lodash/get";

import { filterStory } from "../../helper/api";
import { AdContainer } from "../../ads";
import CollectionTitleHeader from "../../molecules/collection-title-header";
import StoryCard12 from "../../molecules/story-card12";
import Separator from "../../atoms/separator";

import "./opinion-stories.m.css";

const OpinionStories = ({ collection, index }) => {
  if (!(collection && collection.items)) {
    return null;
  }
  const stories = filterStory(collection);

  if (!stories.length) {
    return null;
  }

  const AdCard = ({ id, mobile }) => {
    const [isMobile, setMobile] = useState(false);

    useEffect(() => {
      if (window && window.innerWidth < 767) {
        setMobile(true);
      } else {
        setMobile(false);
      }
    }, []);
    if (index !== 1) return null;
    return (
      <>
        {isMobile ? (
          <div styleName="ad-wrapper" className="hide-desktop">
            <AdContainer AdClassName="standard-336x280" id={id} mobile={mobile} />
          </div>
        ) : null}
      </>
    );
  };

  const mobileAdUnitId1 = get(collection, ["associated-metadata", "mobileAdUnitId1"], null);
  const mobileAdUnitId2 = get(collection, ["associated-metadata", "mobileAdUnitId2"], null);

  return (
    <>
      <CollectionTitleHeader collection={collection} index={index} />
      <div styleName="border-wrapper">
        <div styleName="wrapper">
          {stories?.splice(0, 4).map((item, index) => (
            <React.Fragment key={index}>
              <StoryCard12 story={item} />
              {index === 2 ? <AdCard id="div-gpt-ad-1680156938221-0" mobile={mobileAdUnitId1} /> : null}
              {index === 6 ? <AdCard id="div-gpt-ad-1680156970809-0" mobile={mobileAdUnitId2} /> : null}
            </React.Fragment>
          ))}
        </div>
        <Separator />
      </div>
    </>
  );
};

export default OpinionStories;
